/**
 * Re-export the languages list and default locale so that it can be more
 * easily used in the code.
 */
import locales from './localesForScripts';

export const DEFAULT_LOCALE = locales.DEFAULT_LOCALE;

export const LOCALES_LIST = locales.LOCALES_LIST;
